import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import ButtonBase from '@mui/material/ButtonBase'
import styles from './SearchResultCard.module.css'
import { CategoryIcon } from '../../recipeCardSubComponents';
import { Add, CookingTimeIcon, PrepTimeIcon, ServingSize } from '../../../iconRef/mealPLanIcons';
import { ServingSizeIcon } from '../../../iconRef/recipePageIcons';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useState } from 'react';
import { decreaseServingSize, formatTime, increaseServingSize } from '../utils';
import { resizeImageIfCloudinary } from '../../../utils/images/cloudinaryUtils';

const SearchResultCard = ({ recipe, selectedRecipeIds, addRecipeId, updateRecipeServingSize }: { recipe: any, selectedRecipeIds: Map<string, { servingSize: number }>, addRecipeId: (recipeId: string) => void, updateRecipeServingSize : (recipeId: string, servingSize: number) => void }) => {
    const cookingTime = formatTime(recipe.metadata.cookingTime)
    const prepTime = formatTime(recipe.metadata.prepTime)

    const maxServing = recipe?.metadata?.maxServing;
    const minServing = recipe?.metadata?.minServing;
    const servingSize = maxServing > minServing
        ? `${minServing}-${maxServing}`
        : `${recipe?.metadata?.maxServing}`;

    const addServing = (recipeId: string, currentServingSize: number) => {
        const newServingSize = increaseServingSize(currentServingSize, maxServing);
        updateRecipeServingSize(recipeId, newServingSize);
    }

    const subtractServing = (recipeId: string, currentServingSize: number) => {
        const newServingSize = decreaseServingSize(currentServingSize, minServing);
        updateRecipeServingSize(recipeId, newServingSize);
    }

    return <Grid className={styles.recipe_card}>
        <Grid className={styles.recipe_image}>
            <img src={resizeImageIfCloudinary(recipe?.metadata?.url, 90, 90, -1, -1, true)} alt={recipe?.metadata.name} />
        </Grid>

        <Grid className={styles.recipe_details}>
            <Typography variant='ingredientText1Outfit' className={styles.recipe_title}>{recipe?.metadata?.name}</Typography>
            <Grid alignItems="center" className={styles.recipe_info}>

                {cookingTime ?
                    <Grid className={styles.cooking_time_container}>
                        <CookingTimeIcon fontSize="small" />
                        <Typography variant='caption4LightOutfit'>{cookingTime}</Typography>
                    </Grid> : null
                }
                {prepTime ?
                    <Grid className={styles.cooking_time_container}>
                        <PrepTimeIcon fontSize="small" />
                        <Typography variant='caption4LightOutfit'>{prepTime}</Typography>
                    </Grid> : null}
                    {servingSize ? (
                        <>
                            <Grid className={styles.serving_size_container}>
                                <ServingSizeIcon />
                                <Grid className={styles.serving_size_text}>
                                    <Typography variant='caption4LightOutfit'>{servingSize}</Typography>
                                </Grid>
                            </Grid>
                        </>
                    ) : null}
            </Grid>
            <Grid className={styles.recipe_extra_info}>
                {recipe?.metadata?.nutritionalValues?.calories ? <Typography component="p" variant="caloriesText" className={styles.recipe_kcal}>{recipe?.metadata?.nutritionalValues?.calories} Kcal</Typography>: null}

                {recipe?.metadata?.diet?.length > 0 ?
                    <Grid className={styles.recipe_diet}>
                        <CategoryIcon category={recipe.metadata.diet[0]} recipeName={recipe?.name} />
                        <Typography noWrap className={styles.recipe_cuisine} variant='caloriesText'>{recipe.metadata.cuisine.join(' • ')}</Typography>
                    </Grid>
                    : null}
            </Grid>
        </Grid>

        {selectedRecipeIds.has(recipe.id) ? (
            <Grid className={styles.recipe_actions}>
                <ButtonBase onClick={() => addServing(recipe.id, selectedRecipeIds.get(recipe.id)?.servingSize ?? 2)} className={styles.add_button}>
                    <AddIcon fontSize='small' />
                </ButtonBase>
                <Grid className={styles.recipe_serving_size}>
                    <ServingSize />
                    <Typography variant='caption4Light'>{selectedRecipeIds.get(recipe.id)?.servingSize || 2}</Typography>
                </Grid>
                <ButtonBase onClick={() => subtractServing(recipe.id, selectedRecipeIds.get(recipe.id)?.servingSize ?? 2)} className={styles.remove_button}>
                    <RemoveIcon fontSize='small' />
                </ButtonBase>
            </Grid>
        ) : (
            <ButtonBase className={styles.recipe_card_button} onClick={() => addRecipeId(recipe.id)}>
                <Add />
            </ButtonBase>
        )}

    </Grid>

}

export default SearchResultCard
